<div id="loading-overlay-spinner" class="loading-overlay spinner" *ngIf="loadingService.isLoading$ | async"></div>
